import React from "react";
import { useState } from "react";

export default function SeeMoreWrapper({ text, limit = 50 ,openModal}) {
  const [seeMoreOpen, setSeeMoreOpen] = useState(false);

  const getTextByLimit = () => {
    if (text) {
      if (text.length > limit) {
        // if (seeMoreOpen) {
        //   return (
        //     <div>
        //       {text}{" "}
        //       <span
        //         className="text-info cursor-pointer font-11px"
        //         onClick={(e) => {
        //           e.stopPropagation();
        //           setSeeMoreOpen(false);
        //         }}
        //       >
        //         Less-
        //       </span>{" "}
        //     </div>
        //   );
        // } else {
          return (
            <div>
              {text.slice(0, limit)}{" "}...{" "}
              <span
                className="text-info cursor-pointer font-11px"
                onClick={(e) => {
                  // e.stopPropagation();
                  // setSeeMoreOpen(true);
                  openModal()
                }}
              >
                More+
              </span>{" "}
            </div>
          );
        // }
      } else {
        return text;
      }
    } else {
      return "";
    }
  };

  return <div>{getTextByLimit()}</div>;
}
